import { render, staticRenderFns } from "./AdvanceDownload.vue?vue&type=template&id=c6bc4a42&scoped=true"
import script from "./AdvanceDownload.vue?vue&type=script&lang=js"
export * from "./AdvanceDownload.vue?vue&type=script&lang=js"
import style0 from "./AdvanceDownload.vue?vue&type=style&index=0&id=c6bc4a42&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6bc4a42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6bc4a42')) {
      api.createRecord('c6bc4a42', component.options)
    } else {
      api.reload('c6bc4a42', component.options)
    }
    module.hot.accept("./AdvanceDownload.vue?vue&type=template&id=c6bc4a42&scoped=true", function () {
      api.rerender('c6bc4a42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Report/AdvanceDownload.vue"
export default component.exports